import { Translate } from 'react-redux-i18n'
import { useBlockNavigation } from '../../../../common/hooks/useBlockNavigation'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'

export const BeforeLeavePopup = ({ isBlock, handleSave, validate }) => {
  const { showPrompt, confirmNavigation, cancelNavigation } =
    useBlockNavigation({ isBlock })

  const handleAllowSave = () => {
    handleSave()
    if (!validate()) {
      confirmNavigation()
    } else {
      cancelNavigation()
    }
  }

  return (
    <PopupAction
      isShow={showPrompt}
      title="alertSetting.SAVE_CHANGES"
      btnCancel={{
        label: 'common.NO',
        isI18n: true,
        event: confirmNavigation,
      }}
      btnSubmit={{
        label: 'common.YES',
        isI18n: true,
        event: handleAllowSave,
      }}
      handleClose={cancelNavigation}
    >
      <Element className="textCenter pb2">
        <Icon
          className="icon-alert"
          style={{ color: '#E8B714', fontSize: 32 }}
        />
        <Element className="pt2" style={{ color: '#3A414B' }}>
          <Translate value="alertSetting.SAVE_CHANGES_CONFIRM_MESS" />
        </Element>
      </Element>
    </PopupAction>
  )
}
